import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';
import { environment } from 'src/environments/environment';

interface DemoStep {
  index: number;
  title: string;
  subtitle?: string;
  hint: string;
  tone: 'blue' | 'green' | 'violet' | 'pink';
}

@Component({
  selector: 'app-homes',
  templateUrl: './homes.component.html',
  styleUrls: ['./homes.component.scss']
})
export class HomesComponent implements OnInit, OnDestroy {

  loading = true;
  wlc: any;
  name = "";
  showProfilePopup = false;
  profile: string;
  commonRef: string;
  total_projects = 0;
  project_step = 0;
  stat_projects = 0;
  stat_documents = 0;
  stat_exchanges = 0;
  stat_tasks = 0;
  showStatutMenu = false;
  activeSubMenu: string | null = null;
  selectedStatus: string = null;
  projectLists: Array<any> = [];
  project_selected = false;
  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };

  constructor(private authService: AuthService, private messageService: MessageService, private route: ActivatedRoute, public cdr: ChangeDetectorRef, private router: Router) { }

  ngOnInit() {
    this.total_projects = this.messageService.getListProject().length;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.name = currentUser.givenName;
    if (!currentUser.familyName || currentUser.familyName.trim() === '') {
      this.showProfilePopup = true;
    }
    this.route.paramMap.subscribe(params => {
      this.wlc = params.get('wlc');
    });
    this.authService.endLoading.subscribe((term) =>{ 
      if(term === "1"){
        this.loading = false;
        this.total_projects = this.messageService.getTotalProject();
      }
    });
    this.authService.changeStepProject.subscribe((term) =>{ 
      if(term){
        this.project_step = Number(term);
      }
    });
    if(this.messageService.getListProject().length > 0) {
      
      this.loading = false;
    }
    //this.getStats();
    this.loadContact();
    if(this.activeProfile) this.loadProjects();
  }

  ngOnDestroy(): void {
    console.log("quitted quitted")
    if(this.authService.getStoredActiveProfileId() == null) {
      console.log("quitted initActiveProfile")
      this.initActiveProfile(this.authService.currentUser.id);
    }
  }

  loadProjects(){
    this.projectLists = this.messageService.getListProject();
    this.authService.getProjects('/fullprojects?limit=50&offset=0&order[motionAt]=desc').subscribe(res => {
        this.projectLists = res['hydra:member'];
        this.projectLists.forEach(project => {
            const bgColor = this.getRandomColor();
            project.randomColor = bgColor;
            project.textColor = this.darkenColor(project.color);
        });
    });
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un service, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }

  getStats(){
    this.authService.getGlobalStats().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.stat_projects = dataArray.totalProject;
      this.stat_documents = dataArray.totalFile;
      this.stat_exchanges = dataArray.totalMessage;
      this.stat_tasks = dataArray.totalTask;
    },
    (error) => {
      alert('Erreur global stats ! : ' + error)
    });
   }

   /** Profil affiché dans le sélecteur (non modifiable, vitrine uniquement) */
  profile_user = {
    initials: 'PL',
    name: 'PAUL LEFÈVRE',
    role: 'Admin'
  };

  current_Project = null;

  /** Projet affiché dans le sélecteur (non modifiable, vitrine uniquement) */
  project = {
    initials: 'PD',
    name: 'Projet Démo 1'
  };

  steps: DemoStep[] = [
    {
      index: 1,
      title: 'Choisissez le profil avec lequel vous voulez tester',
      hint: 'Le profil détermine vos droits et votre expérience dans l\u2019outil.',
      tone: 'blue'
    },
    {
      index: 2,
      title: 'Choisissez votre projet',
      hint: 'Sélectionnez un des trois projets démo dans la liste de gauche.',
      tone: 'green'
    },
    {
      index: 3,
      title: 'Vous pouvez aussi inviter un collaborateur par mail',
      subtitle: 'Inviter un collaborateur pour tester les échanges à deux ou à trois',
      hint: 'Ou vous pouvez tester seul en changeant de profil.',
      tone: 'violet'
    },
    {
      index: 4,
      title: 'Vous pouvez ajouter un collaborateur par mail',
      subtitle: 'Ajoutez une personne pour échanger avec vous.',
      hint: 'Invitez un collaborateur pour tester les échanges à deux ou à trois.',
      tone: 'pink'
    }
  ];
  copiedContactId: any = null;
  profileMenuOpen = false;
  projectMenuOpen = false;
  activeProfile: any = null;
  currentUser: any;
  contacts = [];
  vibrantColors = [
      "#FF5733", // Rouge vif
      "#FF8D1A", // Orange vif
      "#F9C74F", // Jaune doré
      "#4CAF50", // Vert
      "#D32F2F", // Rouge profond
      "#9C27B0", // Violet
      "#E91E63", // Rose
      "#FFEB3B", // Jaune
      "#00BCD4", // Bleu clair
      "#8BC34A", // Vert lime
      "#FF5722", // Orange foncé
      "#3F51B5", // Bleu indigo
      "#9E9D24", // Jaune-vert
      "#F44336", // Rouge éclatant
      "#00C853", // Vert vif
      "#9E1B32", // Rouge sombre
      "#F50057", // Rose fuchsia
      "#FF7043", // Orange corail
      "#8E24AA", // Violet intense
      "#388E3C"  // Vert forêt
  ];

  copyInvitationLink(contact: any, userPosition = 0, event: MouseEvent): void {
        event.stopPropagation();
  
        const token = localStorage.getItem("externalToken")
  
        if (!token) {
          console.error('Token introuvable');
          return;
        }
  
        const invitationLink =
          `${environment.app_url}open?token=${token}&user=${userPosition}`;
  
        navigator.clipboard.writeText(invitationLink).then(() => {
  
          // Afficher "Copié !"
          this.copiedContactId = contact.id;
  
          // Revenir à l'icône copier après 2 secondes
          setTimeout(() => {
            this.copiedContactId = null;
          }, 2000);
  
        }).catch(error => {
          console.error('Impossible de copier le lien', error);
        });
  }

  selectProject(project: any) {
    this.authService.projectselected.next(project);
  }
  
  
  selectProfile(contact: any) {
        if (contact.user.id === this.authService.currentUser.id && this.activeProfile) {
          this.profileMenuOpen = false;
          return;
        }
  
        this.authService.switchProfile(contact.user.id).subscribe(
          resp => {
            // Stocke le nouveau token (adapte au nom de clé que ton AuthService utilise déjà)
            localStorage.setItem('token', resp['token']);
            if (resp) {
                  localStorage.setItem('currentUser', JSON.stringify(resp));
                  localStorage.setItem('lang_site', 'fr');
                  localStorage.setItem('lang_discuss', 'fr');
                  localStorage.setItem('notifDiscussion', "2");
                  localStorage.setItem('notifReport', "1");
                  localStorage.setItem('notified', "all");
                  localStorage.setItem('notifAtions', "1");
                  localStorage.setItem('notifMode', "100");
                  localStorage.setItem('notifprojectMode', "100");
                  localStorage.setItem('notifModeAction', "100");
                  localStorage.setItem('notifModeReunion', "100");
                  localStorage.setItem('hideNav', '0');
                  this.authService.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                  var secteur  = this.currentUser.comType;
                  localStorage.setItem('firstConnection', resp['firstConnection']);
                  var langapp  = this.currentUser.langapp;
                  var langmsg  = this.currentUser.langmsg;
                  var translate  = this.currentUser.translate;
                  if(langapp && langapp != "") {
                    localStorage.setItem('lang_site', langapp);
                  } 
                  if(langmsg && langmsg != "") {
                    localStorage.setItem('lang_discuss', langmsg);
                  } 
                  localStorage.setItem('translate', translate);
                  if(secteur === "Réseaux de Magasins"){
                    secteur = "magasins";
                  } else if(secteur === "Réseaux de Clients"){
                    secteur = "clients";
                  } else {
                    secteur = "groupes";
                  }
                  localStorage.setItem('secteur', secteur);
                  this.messageService.setShowCreateProjectTuto(true);
                  //this.messageService.setSound(resp['sound']);
                  this.messageService.setSound(resp['sound']);
                  this.messageService.setShowProjectTuto(true);
                  this.messageService.setShowProjectTutobis(true);
                  this.messageService.setShowNotifTuto(true);
                  this.activeProfile = contact;
                  this.authService.saveActiveProfileId(contact.user.id);
                  this.initActiveProfile();
                  window.location.reload();
                }
  
            // Recharge complètement l'app pour repartir avec le bon contexte utilisateur
          },
          err => {
            alert('Impossible de basculer vers ce profil');
          }
        );
  }

  getInitialsProject(libelle: string): string {
    const words = libelle.split(' ');
    //return "rrr";
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
    return initials;
  }

  getInitials(contact: any): string {
      if (!contact || !contact.user) return '';
      const given = contact.user.givenName || '';
      const family = contact.user.familyName || '';
      return (given.charAt(0) + family.charAt(0)).toUpperCase();
  }

  getRoleLabel(contact: any): string {
      if (contact.isCreator) return 'Admin';
      if (contact.isAdmin) return 'Co-Admin';
      return 'Collaborateur';
  }

  /*
  initActiveProfile() {
      this.activeProfile = this.contacts.find(c => c.user && c.user.id === this.authService.currentUser.id);
      this.cdr.detectChanges();
  }*/

  initActiveProfile(active = null) {
    console.log("quitted initActiveProfile")
    const storedId = this.authService.getStoredActiveProfileId();
    const targetId = storedId !== null && storedId !== undefined
      ? storedId
      : (this.authService.currentUser.id);
    console.log("quitted targetId : "+targetId)
    this.activeProfile =
      this.contacts.find(c => c.user && c.user.id === targetId) ||
      this.contacts.find(c => c.user && c.user.id === this.authService.currentUser.id);
    this.authService.saveActiveProfileId(targetId);
    this.cdr.detectChanges();
  }

  toggleProfileMenu() {
      this.profileMenuOpen = !this.profileMenuOpen;
  }

  toggleProjectMenu() {
      this.projectMenuOpen = !this.projectMenuOpen;
  }

  loadContact(forceRefresh = false) {
        if (!forceRefresh) {
          const cached = this.authService.getStoredContacts();
          if (cached && cached.length) {
            this.contacts = cached;
            this.authService.contacts = cached;
            console.log("quitted initActiveProfile from load contact cashed")
            this.initActiveProfile();
            return; // pas d'appel API
          }
        }
      this.authService.getUserCompagnyMember(this.authService.currentUser['compId']).subscribe(res => {
        this.contacts = res['hydra:member'];
        this.contacts.sort((a, b) => {
         if (a.isCreator !== b.isCreator) {
            return a.isCreator ? -1 : 1;
          }

          // 2. Ensuite les admins
          if (a.isAdmin !== b.isAdmin) {
            return a.isAdmin ? -1 : 1;
          }
          return this.getContactName(a).localeCompare(this.getContactName(b));
        });
        this.contacts.forEach(contact => {
          contact.user.color = this.getRandomColor();
        });
        this.authService.saveContacts(this.contacts);
        console.log("quitted before getStoredActiveProfileId")
        if(this.authService.getStoredActiveProfileId() !== null) {
          const v = this.authService.getStoredActiveProfileId();
          console.log(typeof v, "quitted : "+JSON.stringify(v));
          console.log("quitted getStoredActiveProfileId "+this.authService.getStoredActiveProfileId())
          this.initActiveProfile();
        }
        //this.loadContactNotRegister();
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
             alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
        });
    }

    getContactName(contact: any): string {
      if (contact && contact.user && contact.user.fullName) {
        return contact.user.fullName.toLowerCase();
      }

      if (contact && contact.email) {
        return contact.email.toLowerCase();
      }

      return '';
    }

    getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
    }

}
